import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRiskMitigationRowGroupedData = createAsyncThunk(
  'alix/risk-mitigation-row-grouped-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/mitigation/tracker/by-supplier?clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
